"use client"

import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { useTranslations } from "next-intl"

/** Shared celebration for every moment real Gooncoin lands in an account —
 * the daily login claim and a completed purchase both use this, so the
 * "you got Gooncoin" moment always looks and feels the same regardless of
 * how it happened. */
export function GooncoinAddedPopup({
  open,
  onOpenChange,
  amount,
  newBalance,
  source,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  amount: number
  newBalance?: number
  source: "daily" | "purchase"
}) {
  const t = useTranslations("gooncoinAddedPopup")

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xs p-0 gap-0 text-center border-none bg-transparent shadow-none" showCloseButton={false}>
        <DialogTitle className="sr-only">
          {t("gooncoinAdded", { amount })}
        </DialogTitle>
        <DialogDescription className="sr-only">
          {source === "daily" ? t("dailyLoginBonus") : t("addedToYourAccount")}
        </DialogDescription>
        <div
          className="rounded-2xl px-6 pt-5 pb-6 flex flex-col items-center gap-2"
          style={{ background: "linear-gradient(160deg, #1a0640 0%, #0d0520 100%)", border: "1px solid rgba(167,139,250,0.3)", boxShadow: "0 0 80px rgba(139,92,246,0.2)" }}
        >
          {/* eslint-disable-next-line @next/next/no-img-element -- animated GIF, next/image would strip the animation */}
          <img src="/gooncoin/gooncoin_spin.gif" alt="" className="w-28 h-28 -mb-1" />
          <div className="text-2xl font-bold text-white">
            +{amount.toLocaleString()} {t("gooncoin")}
          </div>
          <div className="text-sm text-purple-200/70">
            {source === "daily" ? t("dailyLoginBonus") : t("addedToYourAccount")}
          </div>
          {typeof newBalance === "number" && (
            <div className="text-xs text-purple-200/50">
              {t("newBalance", { balance: newBalance.toLocaleString() })}
            </div>
          )}
          <button
            onClick={() => onOpenChange(false)}
            className="mt-2 w-full rounded-lg py-2.5 font-bold text-sm text-white transition-colors"
            style={{ background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)" }}
          >
            {t("nice")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
